<header id="top-bar" class="navbar-top">
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs-example-navbar-collapse-1"
          aria-expanded="false"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <a
          class="navbar-brand"
          [routerLink]="!isEfetiveMais ? '/ficha' : 'efetive-mais'"
        >
          <h1>OMNI - Soluções Financeiras</h1>
        </a>
      </div>

      <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
        <ul class="nav navbar-nav links">
          <li
            routerLinkActive="active"
            *ngIf="
              !isOperadorLiberaCessao && !isEfetiveMais && !isLojistaTipoFabrica
            "
          >
            <a routerLink="/ficha">Fichas</a>
          </li>

          <li
            routerLinkActive="active"
            *ngIf="
              (posuiVeiculos || posuiCreditoPessoal) && showSimuladorMenu && !isEfetiveMais
            "
          >
            <a routerLink="/simulador-veiculo">Simulador</a>
          </li>

          <li
            routerLinkActive="active"
            *ngIf="posuiVeiculos || posuiCreditoPessoal"
          >
            <a routerLink="/meu-desempenho">Meu Desempenho</a>
          </li>

          <li
            routerLinkActive="active"
            *ngIf="
              possuiCdcLojaOuPremium && !posuiCreditoPessoal && isOperadorLiberaCessao && !isEfetiveMais
            "
          >
            <a routerLink="/produtos/cdcloja/cessao">Cessão</a>
          </li>

          <li
            routerLinkActive="active"
            *ngIf="
              (possuiCdcLojaOuPremium && !posuiCreditoPessoal && !isEfetiveMais) || isLojistaTipoFabrica
            "
          >
            <a routerLink="/produtos/cdcloja/relatorios">Relatórios</a>
          </li>
        </ul>

        <ul class="nav navbar-nav navbar-right">
          <li class="user dropdown">
            <a
              class="dropdown-toggle"
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              title="Opções do usuário"
            >
              <span
                class="user-photo"
                style="
                  background: url(https://omnifacil2.omni.com.br/bs/images/user.png);
                "
              ></span>
              <div class="name hidden-sm">
                <span>
                  <label>Usuário</label
                  ><strong>{{ loginStorage?.login }}</strong>
                  <small class="user-info">
                    <label>Agente</label>{{ loginStorage?.agente?.id }} -
                    {{ loginStorage?.agente?.nome }}</small
                  >
                  <small class="user-info">
                    <label>Agente Omni da Cidade</label>
                    {{ loginStorage?.agente?.cidade }} -
                    {{ loginStorage?.agente?.uf }}</small
                  >
                </span>
              </div>
              <span class="fa fa-chevron-down" *ngIf="!isEfetiveMais"></span>
            </a>
            <ul class="dropdown-menu menu-bar" *ngIf="!isEfetiveMais">
              <li *ngIf="loginStorage?.usuario?.agentesSelecionarSize > 1">
                <a
                  (click)="onClickSelectAgente()"
                  data-toggle="modal"
                  data-target="#agente"
                >
                  <span class="fa fa-exchange"></span> Alterar Agente</a
                >
              </li>
              <li
                role="separator"
                class="divider"
                *ngIf="loginStorage?.usuario?.agentesSelecionarSize > 1"
              ></li>
              <li>
                <a routerLink="/configuracoes">
                  <span class="fa fa-cog"></span>
                  Configurações
                </a>
              </li>
              <li>
                <a>
                  <span class="fa fa-bookmark"></span> Versão {{ version }}</a
                >
              </li>
              <li role="separator" class="divider"></li>
              <li>
                <a (click)="sair()">
                  <span class="fa fa-sign-out"></span> Sair</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<app-select-agente #selecionarAgente></app-select-agente>

<app-modal-message
  #modalMessage
  title="Atenção"
  message="Falha na Comunicação, verifique sua conexão."
  [hideClose]="true"
></app-modal-message>
